import React, { useState } from "react";
import { toastWarning } from "../../../shared/helpers";

import { PrimaryButton } from "../../atoms/Buttons";

import loadIcon from "../../../assets/images/tail-spin.svg";

import { P } from "../../atoms/Texts";
import ModalHolder from "../../molecules/ModalHolder";

const DeleteReferralFormModal = ({ closeModal, formId }) => {
  const [deleting, setDeleting] = useState(false);

  const onDeleteForm = () => {
    toastWarning("This feature is not available in the demo version");
  };

  return (
    <ModalHolder closeModal={closeModal} header="Delete Service">
      <section className="py-4 md:py-6">
        <P className="mb-4">
          Deleting this form is irreversible, are you certain of this action?
        </P>
        <PrimaryButton.Danger disabled={deleting} onClick={onDeleteForm}>
          {!deleting ? (
            "Delete Form"
          ) : (
            <img src={loadIcon} alt="Loading" className="mx-auto h-6 w-6" />
          )}
        </PrimaryButton.Danger>
      </section>
    </ModalHolder>
  );
};

export default DeleteReferralFormModal;
